import { baseApi } from '../api/baseApi'
import { GATEWAY_URLS } from '../api/urls'

/** Кто вошёл — то, что нужно клиенту, без токенов и без лишних клеймов. */
export interface SessionUser {
  userId: string
  displayName: string
  roles: readonly string[]
}

function text(value: unknown): string | undefined {
  return typeof value === 'string' && value.trim() !== '' ? value : undefined
}

/**
 * Ответ `/auth/me` пакета Kalmykov.Auth.Client.Bff: поля лежат в корне или в
 * `data` в зависимости от версии пакета. Берём только идентификатор, имя и роли;
 * всё прочее (почта, tenant) клиенту нового контура не нужно.
 */
export function decodeSessionUser(raw: unknown): SessionUser {
  if (typeof raw !== 'object' || raw === null) throw new Error('ответ /auth/me не объект')
  const root = raw as Record<string, unknown>
  const data = typeof root.data === 'object' && root.data !== null ? (root.data as Record<string, unknown>) : {}
  const pick = (name: string) => text(root[name]) ?? text(data[name])
  const userId = pick('sub') ?? pick('userId') ?? pick('id')
  if (userId === undefined) throw new Error('в ответе /auth/me нет sub')
  const given = pick('given_name') ?? pick('firstName')
  const family = pick('family_name') ?? pick('lastName')
  const displayName = [given, family].filter((part) => part !== undefined).join(' ') || pick('email') || userId
  const rolesRaw = Array.isArray(root.roles) ? root.roles : Array.isArray(data.roles) ? data.roles : []
  return { userId, displayName, roles: rolesRaw.filter((role): role is string => typeof role === 'string') }
}

export const sessionApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    sessionMe: build.query<SessionUser, void>({
      query: () => ({ url: GATEWAY_URLS.me, decode: decodeSessionUser }),
      // «Кто я» не устаревает таймером: его меняет только вход/выход.
      keepUnusedDataFor: 24 * 60 * 60,
    }),
  }),
})
